module.exports = __webpack_public_path__ + "static/img/menu1.69b6ccec.png";